module.exports = __webpack_public_path__ + "img/CM-KT-25-Cadillac-Playful.17ca2a05.jpg";